import { createLogic } from "redux-logic";
import { type SetFinanceOption, USC_BASKET_SET_FINANCE_OPTION } from "../actions/UscBasketActions";
import { invalidateCode } from "../actions/UscSaveActions";
import { replaceQueryParams } from "../../../../common-deprecated/History";
import type { UscLogicType } from "../store";

const financeOptionLogic = (createLogic as UscLogicType<SetFinanceOption>)({
    type: USC_BASKET_SET_FINANCE_OPTION,

    process({ action }, dispatch, done) {
        // CCSave keeps track of finance option, invalidate whenever it changes.
        dispatch(invalidateCode());

        // Make sure the current URL reflects the new option as well
        if (!action.disableQueryUpdate) replaceQueryParams({ financeOption: action.option });
        done();
    },
});

export default [financeOptionLogic];
